export type ThingsToKnowTip = {
  title: string;
  body: string;
};

export const THINGS_TO_KNOW_TIPS: ThingsToKnowTip[] = [
  {
    title: 'Travel documents',
    body: 'Bring a passport valid for at least 6 months beyond your disembarkation date, plus any visas required for your destination.',
  },
  {
    title: 'Dive certification',
    body: 'Have your certification card (physical or digital) ready. Advanced sites may require logged dive experience.',
  },
  {
    title: 'Rental gear',
    body: 'Complete rental gear sizes in trip management so the boat can prepare equipment before boarding.',
  },
  {
    title: 'Flights & transfers',
    body: 'Add arrival and departure flight numbers early so airport transfers can be coordinated with the operator.',
  },
];
